import _classCallCheck from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var Bounce = /*#__PURE__*/function () {
  function Bounce() {
    _classCallCheck(this, Bounce);
    this.distance = 200;
  }
  _createClass(Bounce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = data.distance;
      }
    }
  }]);
  return Bounce;
}();